import React from 'react'

import { cn } from '@/legacy-src/lib/utils'

type Props = { children: React.ReactNode; className?: string; isPublicList?: boolean }

const TherapistCardGrid: React.FC<Props> = ({ children, className = '', isPublicList = false }) => {
  return (
    <div
      className={cn(
        'grid justify-items-center gap-6 tablet:grid-cols-2 lg:gap-8 laptop:grid-cols-3',
        isPublicList && 'big-tablet:grid-cols-3',
        className,
      )}
    >
      {children}
    </div>
  )
}

export default TherapistCardGrid
